<abi-spinner *ngIf="!job || posting"></abi-spinner>

<div ngClass.gt-xs="card-deck">
    <div class="d-flex justify-content-between">
        <h4 class="mb-0 float-left" translate="Job.Customer"></h4>
        <img
            class="d-inline d-md-none logo pb-2"
            [src]="'assets/logos-big/' + tenant + '.svg?v=1'"
            [alt]="tenant"
        />
    </div>
<mat-divider class="py-2"></mat-divider>
<div class="row">
    <div class="col-12 col-md-6">
        <dl class="row mb-0">
            <dt class="col-md-4" translate="Contact.Name"></dt>
            <dd class="col-md-8">
                <span>{{ job?.contact | contact: 'nameOnly' }}</span>
            </dd>

            <ng-container *hasTranslation="'Contact.Company'">
                <ng-container *ngIf="job?.contact?.companyName">
                    <dt class="col-md-4" translate="Contact.Company"></dt>
                    <dd class="col-md-8">
                        <span>{{ job?.contact?.companyName }}</span>
                    </dd>
                </ng-container>
            </ng-container>

            <dt class="col-md-4" translate="Address.Address"></dt>
            <dd class="col-md-8 pre-wrap">{{ job?.address | address }}</dd>

            <dt class="col-md-4" translate="Contact.Mobile"></dt>
            <dd class="col-md-8">{{ job?.contact?.mobile }}</dd>
        </dl>
    </div>
    <div class="col-12 col-md-6">
        <dl class="row mb-0">
            <dt class="col-md-12">
                <div class="custom-control custom-checkbox pl-2 pb-2">
                    <input type="checkbox" class="custom-control-input" id="companyInvoice" [(ngModel)]="editVat"/>
                    <label class="custom-control-label" for="companyInvoice">{{ 'Company Invoice' | translate }}</label>
                </div>
            </dt>
        </dl>

        <dl class="row mb-0" *ngIf="editVat">
            <ng-container *hasTranslation="['Contact.Company']">
                <dt class="col-md-4 field-label" translate="Contact.Company"></dt>
                <dd class="col-md-8 field-input">
                    <input
                    *ngIf="editVat"
                    [readonly]="!editVat"
                    type="text"
                    [(ngModel)]="companyName"
                    (ngModelChange)="vatDetailsChanged = true"
                />
                </dd>
            </ng-container>

            <dt class="col-md-4 field-label" translate="Customer.VatNumber">
            </dt>
            <dd class="col-md-8 field-input">
                <input
                    [class.invisible]="!editVat"
                    type="text"
                    [(ngModel)]="vatNumber"
                    [mask]="vatMask"
                    (ngModelChange)="vatDetailsChanged = true"
                />
            </dd>
            <ng-container *ngIf="vatDetailsChanged">
                <dt class="col-md-4 field-label" translate="Update Details">
                </dt>
                <dd class="col-md-8 field-input">
                    <button

                        type="button"
                        class="btn btn-primary"
                        (click)="updateJob($event)"
                        translate="Update Details"
                    ></button>
                </dd>
            </ng-container>
        </dl>
    </div>
</div>

<div *ngIf="isMobile | async; then paymentTable"></div>
    <div class="d-flex justify-content-between">
        <h4 class="align-self-end">{{ 'Job.Job' | translate }} / {{ 'Job.Machine' | translate }}</h4>
        <img
            class="d-none d-md-inline logo pb-2"
            [src]="'assets/logos-big/' + tenant + '.svg?v=1'"
            [alt]="tenant"
        />
    </div>
    <mat-divider></mat-divider>
    <dl class="row my-2">
        <dt class="col-md-4" translate="Job.JobID"></dt>
        <dd class="col-md-8">{{ job?.jobId }}</dd>
        <dt class="col-md-4" translate="Job.QuoteDate"></dt>
        <dd class="col-md-8">{{ job?.created | date }}</dd>
            <ng-container *hasTranslation="'Job.ExpireDate'">
                <dt class="col-md-4" translate="Job.ExpireDate"></dt>
                <dd class="col-md-8">{{ job?.nextAction | date }}</dd>
            </ng-container>
        <dt class="col-md-4" translate="Machine.ModelID"></dt>
        <dd class="col-md-8">
            {{ job?.machine?.modelId }} ~ {{ job?.machine?.name }}
        </dd>
        <dt class="col-md-4" translate="Job.FaultCodeID"></dt>
        <dd
            class="col-md-8"
            [abiLookupdisplayValue]="job?.faultCodeId"
            listName="CodeJobFault"
        ></dd>
        <dt class="col-md-4" translate="Job.StatusID"></dt>
        <dd
            class="col-md-8"
            [abiLookupdisplayValue]="job?.statusId"
            listName="CodeJobStatus"
        ></dd>
        <dt class="col-md-4" translate="Job.FaultDescription"></dt>
        <dd class="col-md-8">{{ job?.faultDescription }}</dd>
        <dt class="col mt-2" translate="JobCod.QuoteValidity"></dt>
    </dl>
</div>

<div class="mt-3">
  <div class="d-flex justify-content-between">
    <ng-container *hasTranslation="['JobCod.MessageSTK', 'JobCod.MessageOldMachine', hasLabourLine() ? 'JobCod.MessageLAB' : '' ]">
        <h4 translate="JobCod.WhatIncluded"></h4>
    </ng-container>

    <div class="float-right">
        <button *hasTranslation="'JobCod.WarrantyText'" type="button" class="btn btn-link" (click)="showWarrantyText(termsDialog)" translate="JobCod.Warranty">
        </button>
        <button type="button" class="btn btn-link" (click)="showText(termsDialog, false)" translate="JobCod.PrivacyNotice">
        </button>
        <button type="button" class="btn btn-link" (click)="showText(termsDialog, true)" translate="JobCod.TermsConditions">
        </button>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="row pt-2">
    <div class="col-sm">
        <ng-container *hasTranslation="['JobCod.MessageSTK', 'JobCod.MessageOldMachine', hasLabourLine() ? 'JobCod.MessageLAB' : '' ]">
            <ul>
                <ng-container *ngIf="hasLabourLine()">
                    <ng-container *hasTranslation="'JobCod.MessageLAB'">
                        <li [innerHTML]="'JobCod.MessageLAB' | translate"></li>
                    </ng-container>
                </ng-container>
                <ng-container *hasTranslation="'JobCod.MessageSTK'">
                    <li [innerHTML]="'JobCod.MessageSTK' | translate"></li>
                </ng-container>
                <ng-container *hasTranslation="'JobCod.MessageOldMachine'">
                    <li [innerHTML]="'JobCod.MessageOldMachine' | translate"></li>
                </ng-container>
            </ul>
        </ng-container>
    </div>
    <div *ngIf="companyAccountNumber" class="col-lg-5">
        <dl class="row mb-0 bank">
            <dt class="col-md-4" translate="JobCod.Account"></dt>
            <dd class="col-md-8">{{ companyAccountName }}</dd>
            <dt class="col-md-4" translate="JobCod.AccountNumber"></dt>
            <dd class="col-md-8">{{ companyAccountNumber }}</dd>
            <dt class="col-md-4" translate="JobCod.BankName"></dt>
            <dd class="col-md-8">{{ companyBankName }}</dd>
            <dt class="col-md-4" translate="JobCod.BranchCode"></dt>
            <dd class="col-md-8"> {{ companyBankBranch }}</dd>
            <dt class="col-md-4" translate="JobCod.Reference"></dt>
            <dd class="col-md-8"> {{ job.jobId }}</dd>
        </dl>
    </div>
  </div>
</div>

<div *ngIf="(isMobile | async) === false; then paymentTable"></div>

<form
  #mygateForm
  ngNoForm
  method="POST"
  [attr.action]="codEnv.adumoApi"
>
    <input type="hidden" name="MerchantID" [value]="codEnv.merchantId" />
    <input type="hidden" name="ApplicationID" [ngModel]="adumoAppId" />
    <input type="hidden" name="Token" [ngModel]="adumoToken" />
    <input type="hidden" name="Mode" value="1" />
    <input
        type="hidden"
        name="MerchantReference"
        [ngModel]="paymentReference()"
    />
    <input type="hidden" name="Amount" [ngModel]="unpaid.toFixed(2)" />
    <input type="hidden" name="txtDisplayCurrencyCode" value="ZAR" />
    <input type="hidden" name="txtCurrencyCode" value="ZAR" />

    <input
        type="hidden"
        name="RedirectSuccessfulURL"
        [ngModel]="(postbackUrl | async) + 'success'"
    />
    <input
        type="hidden"
        name="RedirectFailedURL"
        [ngModel]="(postbackUrl | async) + 'fail'"
    />

    <input
        *ngIf="editVat"
        type="hidden"
        name="CompanyName"
        [ngModel]="companyName"
    />
    <input *ngIf="editVat" type="hidden" name="VatNumber" [ngModel]="vatNumber" />
</form>

<div class="mt-5 text-center" *ngIf="canPay()">
    <a target="_blank" href="http://www.credit-card-logos.com">
        <img alt="MasterCard and Visa Logo" src="https://developers.adumoonline.com/images/logos/mc_vs.png" height="65" width="210" />
    </a>

    <a target="_blank" href="https://www.adumoonline.com">
        <img alt="Adumo Online Logo" src="https://developers.adumoonline.com/images/logos/Adumo_Online_logo.png" height="50" width="183" />
    </a>
</div>


<ng-template #termsDialog>
    <div mat-dialog-content [innerHTML]="dialogText  | translate"></div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
    </div>
</ng-template>

<ng-template #cancelDialog>
    <h5 mat-dialog-title>Confirm</h5>
    <div mat-dialog-content>
        <ul class="list-unstyled">
        <li *ngFor="let msg of confirmMsg">{{ msg | translate }}</li>
        </ul>
    </div>
    <div mat-dialog-actions>
        <button mat-button [mat-dialog-close]="false">
        No
        </button>
        <button mat-button [mat-dialog-close]="true">
        Yes
        </button>
    </div>
</ng-template>

<ng-template #paymentTable>
  <div class="mt-2">
    <h4>Items</h4>

    <div *ngIf="(isMobile | async) === false; else mobilePage" class="table-responsive">
      <table class="table table-sm">
        <thead class="thead-light">
            <tr>
                <!--th class="text-nowrap d-none d-md-table-cell">
                    Type
                    </th-->
                <th class="w-20" translate="JobLine.ItemID"></th>
                <th class="text-nowrap w-30" translate="JobLine.Description"></th>
                <th *ngIf="prePayment" class="text-right" translate="JobCod.DateAvail"></th>
                <th class="text-right w-5" translate="JobLine.Quantity2"></th>
                <th class="w-8 text-right" translate="JobLine.Price"></th>
                <th class="w-8 text-right" translate="JobLine.Amount2"></th>
                <th class="text-center" translate="JobLine.Paid"></th>
                <th translate="Job.Invoice"></th>
                <th *ngIf="!prePayment" translate="JobLine.Receipt"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let line of job?.lines">
                <!--td class="text-nowrap d-none d-md-table-cell" [abiLookupdisplay]="line.typeId" listName="JobLineType">
                    </td-->
                <td class="w-20">
                {{ line.itemId }}
                </td>
                <td class="text-nowrap w-30">
                {{ line.line1 }}
                </td>
                <td *ngIf="prePayment" class="text-right text-nowrap">
                {{ availableText(line) }}
                </td>
                <td class="text-right">
                {{ line.quantityOrdered }}
                </td>
                <td class="w-8 text-right text-nowrap">
                {{ line | jobline: "priceVat" }}
                </td>
                <td class="w-8 text-right text-nowrap">
                {{ line | jobline: "amount" }}
                </td>
                <td class="text-center">
                <i [class]="line.receipt || line.paid ? 'fas fa-check' : ''"></i>
                </td>
                <td>
                <a [routerLink]="['invoice', line.invoice]">{{ line.invoice }}</a>
                </td>
                <td *ngIf="!prePayment">
                <a [routerLink]="['receipt', line.receipt]">{{ line.receipt }}</a>
                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td colspan="2"></td>
                <td *ngIf="prePayment"></td>
                <td class="text-right" translate="JobCod.VAT"></td>
                <td class="text-right">15%</td>
                <td class="text-right">{{ vat | number: "1.2-2" }}</td>
                <td colspan="3"></td>
            </tr>
            <tr>
                <td colspan="2"></td>
                <td *ngIf="prePayment"></td>
                <td class="text-right" translate="JobLine.TotalIncVat"></td>
                <td colspan="2" class="text-right">
                {{ total | number: "1.2-2" }}
                </td>
                <td [attr.colspan]="3 - prePayment"></td>
            </tr>

            <tr class="table-secondary">
                <td colspan="2">
                <ng-container *ngTemplateOutlet="notAcceptBtn"></ng-container>
                </td>
                <td *ngIf="prePayment"></td>
                <td class="text-right align-middle" translate="JobLine.Unpaid"></td>
                <td></td>
                <td class="text-right font-weight-bold align-middle">
                {{ unpaid | number: "1.2-2" }}
                </td>
                <td [attr.colspan]="2 - prePayment"></td>
                <td>
                <ng-container *ngTemplateOutlet="acceptBtn"></ng-container>
                </td>
            </tr>
        </tfoot>
      </table>
    </div>

    <ng-template #mobilePage>
      <div class="table-responsive">
        <table class="table table-sm">
          <thead class="thead-light">
                <tr>
                    <th class="text-nowrap w-40" translate="JobLine.Description"></th>
                    <th class="text-right w-5" translate="JobLine.Quantity"></th>
                    <!--th class="w-8 text-right">
                        Price
                        <span *ngIf="prePayment">
                            /&nbsp;Avail
                        </span>
                        </th-->
                    <th class="w-8 text-right" translate="JobLine.Amount"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let line of job?.lines">
                    <!--td class="text-nowrap d-none d-md-table-cell" [abiLookupdisplay]="line.typeId" listName="JobLineType">
                    </td-->
                    <td class="w-15">
                        {{ line.itemId }}
                        <p>
                        <small>{{ line.line1 }}</small>
                        </p>
                    </td>
                    <td class="text-right">
                        {{ line.quantityOrdered }}
                    </td>
                    <!--td class="w-8 text-right text-nowrap d-none d-md-table-cell">
                        {{ line | jobline:'costPrice' }}
                        <p class="d-md-none d-block">
                            <small>{{ availableText(line) }} </small>
                        </p>
                        </td-->
                    <td class="w-8 text-right text-nowrap">
                        {{ line | jobline: "amount" }}
                        <a
                        class="d-md-none d-block"
                        [routerLink]="['invoice', line.invoice]"
                        >{{ line.invoice }}</a
                        >
                        <a
                        class="d-md-none d-block"
                        [routerLink]="['receipt', line.receipt]"
                        >{{ line.receipt }}</a
                        >
                    </td>
                </tr>
          </tbody>
          <tfoot>
                <tr>
                    <td></td>
                    <td class="text-right" translate="JobCod.VAT"></td>
                    <td class="text-right">{{ vat | number: "1.2-2" }}</td>
                    </tr>
                    <tr>
                    <td></td>
                    <td class="text-right" translate="JobLine.TotalIncVat"></td>
                    <td class="text-right">{{ total | number: "1.2-2" }}</td>
                    </tr>
                    <tr class="table-secondary">
                    <td></td>
                    <td class="text-right align-middle" translate="JobLine.Unpaid"></td>
                    <td class="text-right font-weight-bold">
                        {{ unpaid | number: "1.2-2" }}
                    </td>
                    </tr>
                    <tr class="table-secondary">
                    <td colspan="3" class="border-top-0">
                        <ng-container *ngTemplateOutlet="notAcceptBtn"></ng-container>
                        <ng-container *ngTemplateOutlet="acceptBtn"></ng-container>
                    </td>
                </tr>
          </tfoot>
        </table>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #notAcceptBtn>
    <ng-container *hasTranslation="'JobCod.NoThanks'">
        <button
            *ngIf="canCancel()"
            [disabled]="!check"
            type="button"
            class="btn btn-outline-primary float-left"
            (click)="cancelJob(cancelDialog)"
            [class.active]="notAccepted()"
            data-testid="cod-cancel"> {{ 'JobCod.NoThanks' | translate }} <br /><i *ngIf="notAccepted(); else empty" class="fas fa-ban"></i>
        </button>
    </ng-container>
</ng-template>

<ng-template #acceptBtn>
    <button
        *ngIf="canPay()"
        [disabled]="!check"
        type="button"
        class="btn btn-primary btn-block"
        (click)="makePayment(mygateForm)"
        data-testid="cod-pay">{{ 'JobCod.Pay' | translate }} <br /><i class="fas fa-shopping-cart"></i>
    </button>

    <ng-container *hasTranslation="'JobCod.Accept'">
        <button
            [disabled]="!check"
            *ngIf="(canAccept() || accepted()) && !canPay()"
            type="button"
            class="btn btn-outline-primary btn-block "
            [class.active]="accepted()"
            (click)="acceptJob(cancelDialog)"
            data-testid="cod-accept"
        >{{ 'JobCod.Accept' | translate }} <br />
            <i
                *ngIf="accepted(); else empty"
                class="fas fa-check-square"
            ></i>
        </button>
    </ng-container>

</ng-template>

<ng-template #empty>
  &nbsp;
</ng-template>

<ng-template #paidDialog>
    <h4 mat-dialog-title translate="JobCod.ManualPayment"></h4>
    <mat-dialog-content [formGroup]="payment">
        <abi-form-field label="JobLine.PaidDate" labelColClass="col-sm-3" [horizontal]="false">
            <div class="input-group">
                <input
                ngbDatepicker
                formControlName="paidDate"
                #dop="ngbDatepicker"
                container="body"
                />
                <div class="input-group-append">
                <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="dop.toggle()"
                >
                    <i class="fas fa-calendar-alt fa-fw"></i>
                </button>
                </div>
            </div>
        </abi-form-field>
        <abi-form-field labelColClass="col-sm-3" label="JobLine.Paid" [horizontal]="false">
        <input type="number" formControlName="paid" [min]="0" [max]="unpaid" />
        </abi-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button [mat-dialog-close]="false" translate="System.Cancel"></button>
        <button
        mat-button
        [disabled]="payment.invalid"
        [mat-dialog-close]="true"
        cdkFocusInitial translate="System.Cancel"></button>
    </mat-dialog-actions>
</ng-template>
